
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.424 8.905a.685.685 0 00.482-.198l2.78-2.755.005-.006.011-.012a.717.717 0 00.034-.037l.01-.014a.698.698 0 00.029-.04l.009-.014a.679.679 0 00.025-.044l.007-.013a.672.672 0 00.022-.048l.004-.011a.695.695 0 00.019-.055l.002-.008.014-.06V5.59l.001-.008a.69.69 0 00.008-.058v-.017c.002-.012.003-.025.003-.038v-.012l-.002-.022a.742.742 0 00-.003-.045l-.003-.024a.658.658 0 00-.007-.042l-.006-.024a.716.716 0 00-.012-.041l-.007-.021a.674.674 0 00-.016-.042l-.008-.018a.66.66 0 00-.021-.042l-.01-.015a.66.66 0 00-.025-.041l-.01-.015a.687.687 0 00-.03-.038l-.013-.015-.026-.029-2.755-2.78a.685.685 0 00-1.172.48l-.01 2.343a7.326 7.326 0 00-3.828 2.876 7.293 7.293 0 00-1.145 5.355 7.291 7.291 0 002.869 4.641.682.682 0 00.958-.145.685.685 0 00-.145-.958 5.941 5.941 0 01-1.4-8.126 5.954 5.954 0 012.684-2.183l-.008 1.732a.685.685 0 00.686.688z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.22 10.744a7.291 7.291 0 00-2.868-4.641.685.685 0 10-.814 1.103 5.941 5.941 0 011.4 8.126 5.955 5.955 0 01-2.684 2.183l.008-1.732a.685.685 0 00-1.168-.49l-2.78 2.755-.004.005-.02.02-.024.03c-.007.007-.013.015-.019.024l-.02.029c-.007.008-.011.017-.017.026-.006.01-.013.02-.018.031l-.012.026c-.006.012-.012.023-.017.036l-.008.021a.686.686 0 00-.015.044l-.004.018a.65.65 0 00-.012.05l-.001.003-.002.016a.653.653 0 00-.007.048v.026l-.003.03v.01l.002.033.003.034.005.035.005.031.008.035.009.03.011.032.012.031.014.029.015.031.016.027.018.03.02.026.02.027.024.027.017.018 2.755 2.78a.685.685 0 001.172-.48l.01-2.342a7.326 7.326 0 003.828-2.876 7.293 7.293 0 001.145-5.355z","fill":"currentColor"}})])
          )
        }
      }
    